"use client";

import Image from "next/image";
import { useEffect } from "react";
import { revealLinesOnScroll, revealImageCurtain } from "@/lib/animations/gsap";

export default function AboutSection() {

    useEffect(() => {
        revealLinesOnScroll(".animated-paragraph", {
            duration: 0.9,
            lineDelay: 0.5,
            y: 40,
        });

        revealImageCurtain(".curtain-image", {
            duration: 1.4,
            start: "top 85%",
        });
    }, [])

    return (
        <div className="flex flex-col items-start justify-start w-full px-5 md:px-20 py-16 md:gap-10">
            
            <div className="flex flex-col md:flex-row items-start justify-start w-full gap-10 md:gap-16">
                
                {/* Image */}
                <div className="flex w-full md:w-1/2 h-auto md:h-[450px]">
                    <div className="relative w-full h-[300px] md:h-full">
                        <Image 
                            src="/images/slider3.png" 
                            alt="mmmlaw-firm" 
                            fill 
                            priority 
                            className="object-cover object-center curtain-image rounded-xl"
                        />
                    </div>
                </div>

                {/* Text content */}
                <div className="flex flex-col w-full md:w-1/2 gap-5 text-black">
                    <h2 className="font-bold text-[28px] md:text-[36px] font-lora leading-8 md:leading-12">
                        At Murimi, Mbago & Muchela Advocates (MMM Law), we have been redefining legal practice in Kenya since 2012.
                    </h2>
                    <p className="text-base md:text-lg leading-relaxed">
                        Our team of three Partners, one Associate Partner, two Senior Associates, and four Associates brings over 70 years of combined experience. Together, we handle corporate transactions, complex disputes, and advisory work with precision and a client-first approach.
                    </p>
                    <p className="text-base md:text-lg leading-relaxed">
                        We began as Murimi, Ndumia, Mbago & Muchela Advocates (MNMM Advocates) and have since evolved into MMM Advocates: a modern identity that honors our roots while embracing the future. Our commitment to quality has earned national recognition. We are ranked among Kenya’s Top 20 Law Firms by Lawyer Africa and were named Best Performing Law Firm in Nakuru County at the 2023 Nakuru Entrepreneurs Awards. At MMM Law, we measure success not just by legal outcomes, but by the value and confidence we bring to every client relationship.
                    </p>
                </div>

            </div>
        </div>
    );
}
